export interface ValidationErrorItem {
  loc?: Array<string | number>;
  msg?: string;
  type?: string;
}

export type ApiErrorPayload = {
  message?: string;
  error?: string;
  detail?: string | ValidationErrorItem[];
};

export function extractErrorMessage(
  data: ApiErrorPayload | undefined,
  fallback = ''
): string {
  const { detail, message, error } = data ?? {};

  if (Array.isArray(detail)) {
    const combined = detail
      .map((item) => item?.msg)
      .filter((msg): msg is string => Boolean(msg))
      .join(', ');
    return combined || fallback;
  }

  return detail ?? message ?? error ?? fallback;
}
